import React from 'react';

const PositiveResult = (props) => {
	const droit = props.model;
	if (droit.value !== true ) { 
		var montant = !droit.floorAt ? droit.value : droit.value - (droit.value % droit.floorAt) ;
	}else {
		var montant = droit.value;
	}
	return (
		<div className="information">
			<p>
				Selon les renseignements que vous avez saisis, vous êtes, a priori en situation de bénéficier de <strong>{montant} &euro;</strong> d'ASPA. Le montant est donné qu'à titre indicatif et est arrondi.
			</p>
			<p><a href="https://www.aide-sociale.fr/minimum-retraite-aspa/" target="_blank"><button className="button">Comment l'obtenir ?</button></a></p>
		</div>
	);
};

export default PositiveResult;
